export default __webpack_public_path__ + "static/media/delivery.0c265f08.png";